import React from 'react';
import { useTranslation } from 'react-i18next';
import { Pagination as SharedPagination } from '@packages/ui';

interface PaginationProps {
  currentPage?: number;
  page?: number;
  limit?: number;
  total?: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  showInfo?: boolean;
}

const Pagination: React.FC<PaginationProps> = (props) => {
  const { t } = useTranslation(['common_ui']);

  return (
    <SharedPagination
      {...props}
      labels={{
        previous: t('common_ui:pagination.previous'),
        next: t('common_ui:pagination.next'),
        showing: ({ start, end, total }) => t('common_ui:pagination.showing', { start, end, total }),
        total: (total) => `${t('common_ui:pagination.totalPrefix', { defaultValue: '共' })} ${total} ${t('common_ui:pagination.totalSuffix', { defaultValue: '项' })}`,
      }}
    />
  );
};

export default Pagination;
